import { setEtfSymbol, setGlobalGroupCode, setGlobalIndustryName } from '@oneview/redux/insights/insightsActions';
import { GlobalGroupCode } from '@orbis-systems/orbis-api-middleware';
import { createReducer } from '@reduxjs/toolkit';

const DEFAULT_STATE: {
    globalIndustryName: string;
    globalGroupCode: GlobalGroupCode;
    symbol: string;
} = {
    globalIndustryName: '',
    globalGroupCode: GlobalGroupCode.BasicMaterial,
    symbol: '',
};

export const insightsReducer = createReducer(DEFAULT_STATE, (builder) => {
    builder.addCase(setGlobalIndustryName, (state, action) => {
        state.globalIndustryName = action.payload;
    });

    builder.addCase(setGlobalGroupCode, (state, action) => {
        state.globalGroupCode = action.payload;
    });

    builder.addCase(setEtfSymbol, (state, action) => {
        state.symbol = action.payload;
    });
});
